<script setup>
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

defineProps({
  populations: { type: Array, default: () => [] },
});

function fmt(value) {
  if (value == null) return "–";
  return Number.isInteger(value) ? String(value) : value.toFixed(1);
}
</script>

<template>
  <!-- With many populations the fixed 120px columns exceed the card width
       (half-width grid cards): scroll horizontally instead of overflowing. -->
  <div class="overflow-x-auto print:overflow-visible">
  <Table
    class="text-xs ml-auto table-fixed"
    :style="{ width: `${Math.min(100, 40 + populations.length * 20)}%` }"
  >
    <TableHeader>
      <TableRow>
        <TableHead class="h-8 px-2 text-xs font-medium w-full" />
        <TableHead
          v-for="pop in populations"
          :key="pop.label"
          class="px-2 py-1.5 text-xs font-medium text-right w-[120px] align-bottom whitespace-normal"
        >
          <span class="line-clamp-2 text-right leading-tight">
            <span
              class="inline-block h-2 w-2 rounded-sm align-middle mr-1"
              :style="{ backgroundColor: pop.color }"
            />
            {{ pop.label }}
          </span>
        </TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      <TableRow>
        <TableCell class="px-2 py-1.5 font-medium">Mean</TableCell>
        <TableCell
          v-for="pop in populations"
          :key="pop.label"
          class="px-2 py-1.5 text-right tabular-nums w-[120px]"
        >
          {{ fmt(pop.mean) }}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell class="px-2 py-1.5 font-medium">Median</TableCell>
        <TableCell
          v-for="pop in populations"
          :key="pop.label"
          class="px-2 py-1.5 text-right tabular-nums w-[120px]"
        >
          {{ fmt(pop.median) }}
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
  </div>
</template>
